var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCity = function SvgCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.964 3.087a.42.42 0 0 0-.09-.47.41.41 0 0 0-.469-.076L2.225 7.967a.401.401 0 0 0 .117.757l4.756.683a.56.56 0 0 1 .472.47l.656 4.285a.396.396 0 0 0 .753.102z"
  })));
};
export default SvgCity;